export const SYSTEM_DEFAULT_CURRENCY_KEY = "system_default_currency";
export const SYSTEM_DEFAULT_CURRENCY_CHANGED_EVENT = "system-default-currency-changed";

export const normalizeCurrencyCode = (value) => {
  const code = String(value || "").trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : "";
};

export const readDefaultCurrencyValue = (value) => {
  const direct = normalizeCurrencyCode(value);
  if (direct) return direct;

  if (value && typeof value === "object") {
    return (
      normalizeCurrencyCode(value.currency) ||
      normalizeCurrencyCode(value.code) ||
      normalizeCurrencyCode(value.value) ||
      ""
    );
  }

  return "";
};

export const fetchSystemDefaultCurrency = async () => {
  return "USD";
};

export const emitSystemDefaultCurrencyChanged = (currencyCode) => {
  if (typeof window === "undefined") return;
  const normalized = "USD";
  window.dispatchEvent(
    new CustomEvent(SYSTEM_DEFAULT_CURRENCY_CHANGED_EVENT, {
      detail: { currency: normalized },
    })
  );
};
